/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collection, CollectionQuery } from "../../../models/collection.model"
import { Notification } from "../../../models/notification.model"
import { Property } from "../../../models/property.model"
import { notification } from "../../../shared/component/notification/utility/notification"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { appApi } from "../../../store/app.api"
import { REPORT_ENDPOINT } from "../reports.endpoint"

let reportCollection: CollectionQuery
const reportsQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getMonthlyLeaseExpirations: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${REPORT_ENDPOINT.getMonthlyLeaseExpirations}`,
        method: "GET",
        params: collectionQueryBuilder(data),
        // permission: "manage-notifications",
      }),
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            reportCollection = param
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

  }),
  overrideExisting: true,
})
export const {
  useLazyGetMonthlyLeaseExpirationsQuery
} = reportsQuery
